import React, { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import { Grid } from '@mui/material';

const PlatformConfig = ({ keyData, sectionIdKey, label, sectionIdList = [] }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const hasSectionIdOptions = sectionIdList.length > 0;

	return (
		<Grid container spacing={1} style={{ padding: '1rem' }}>
			<Grid item xs={2}>
				<CheckBoxInput
					keyData={`${keyData}.enabled`}
					label="enabled"
					disabled={!hasSectionIdOptions}
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: 'fit-content', marginTop: '4rem' }}
				/>
			</Grid>
			<Grid item xs={5}>
				<CheckBoxInput
					keyData={`${keyData}.keepFloatingRestSession`}
					label="keep floating rest of session"
					disabled={false}
					defaultChecked={false}
					object={rawConfig}
					updateObject={updateRawConfig}
					containerStyles={{ width: 'fit-content', marginTop: '4rem' }}
				/>
			</Grid>
			<Grid item xs={4}>
				<DropDownSingle
					label={label}
					keyData={`${keyData}.${sectionIdKey}`}
					list={sectionIdList}
					object={rawConfig}
					updateObject={updateRawConfig}
					disabled={!hasSectionIdOptions}
				/>
			</Grid>
		</Grid>
	);
};

export default PlatformConfig;
